import React from 'react';
import { AvatarLarge } from '../../components';

import css from './ProfilePage.module.css';

const AsideContent = props => {
  const { user, displayName } = props;

  return (
    <div className={css.asideContent}>
      <div className={css.asideContentWrapper}>
        <AvatarLarge
          className={css.avatar}
          initialsClassName={css.avatarInitials}
          user={user}
          useUserTier
          disableProfileLink
        />
        <h2 className={css.asideTitle}>{displayName}</h2>
      </div>
    </div>
  );
};

export default AsideContent;
